import { connectHook } from 'app/common/components/connect-hook';
import { ProjectMenu } from './project-menu';
import { useProjectMenu } from './project-menu-hook';

export default connectHook(ProjectMenu, useProjectMenu);
